import { useRecommendations } from 'src/api/recommendation'
import { withLoginUser } from 'src/api/user'
import { RecommendLayout } from './RecommendLayout'

export const Recommend = withLoginUser(({ user }) => {
  const recommendations = useRecommendations()
  return (
    <RecommendLayout
      user={user}
      recommendedUsers={recommendations.data || []}
    />
  )
})
